import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { boardCompetencies, pillars, positioning } from '../data/profile';
export function ValueProposition() {
  return <PageShell path="/value-proposition" data-id="element-406" data-mp="1dg0rorf9uejw">
      <section id="proposition" className="bg-white py-20 lg:py-24" aria-labelledby="proposition-heading" data-id="element-407" data-mp="1diwq0gv1758v">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-408" data-mp="kseovldvbdy3">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-409" data-mp="kswrczr4ioeg">
            <div className="lg:col-span-5" data-id="element-410" data-mp="pqg57yjwsz5v">
              <div id="proposition-heading" data-id="element-411" data-mp="ptub3grs7qi2">
                <SectionHeading eyebrow="Value Proposition" title="What she brings to the table" data-id="element-412" data-mp="urm1g6cs34k5" />
              </div>
            </div>
            <div className="lg:col-span-7" data-id="element-413" data-mp="216daixc21vp9">
              <div className="border-t-2 border-gold-500 bg-platinum-100 p-8 lg:p-10" data-id="element-414" data-mp="26580cj8fwkiv">
                <p className="font-display text-xl font-semibold leading-snug tracking-tight text-navy-900 lg:text-2xl" data-id="element-415" data-mp="1la9dpjtypjrz">
                  {positioning}
                </p>
              </div>
            </div>
          </div>

          <div id="pillars" className="mt-20 scroll-mt-24" data-id="element-416" data-mp="1c91ri04q09e9">
            <h2 className="font-display text-2xl font-bold tracking-tight text-navy-900" data-id="element-417" data-mp="1cbnvxqwbe8s9">
              Four pillars of executive value
            </h2>
            <div className="mt-8 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 md:grid-cols-2" data-id="element-418" data-mp="12cf9dj3s3wfx">
              {pillars.map((pillar, index) => <motion.article key={pillar.number} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.28,
              delay: index % 2 * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-419" data-mp="slc6qcv7b9ej" data-mpi={index}>
                  <div className="flex items-baseline gap-4" data-id="element-420" data-mp="4xfc21tqcbia">
                    <span className="font-display text-sm font-bold tracking-[0.12em] text-gold-600" data-id="element-421" data-mp="9xjw21tujod9">
                      {pillar.number}
                    </span>
                    <h3 className="font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-422" data-mp="3r7hxkjgmrh1x">
                      {pillar.title}
                    </h3>
                  </div>
                  <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-423" data-mp="npgfzild2ryk">
                    {pillar.description}
                  </p>
                  <ul className="mt-auto space-y-2.5 pt-7" data-id="element-424" data-mp="dzoleod9hyu3">
                    {pillar.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-425" data-mp="ixgg1q5ajz1z">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-426" data-mp="16o2jt589ix66" />
                        <span className="font-sans text-sm font-medium text-navy-900" data-id="element-427" data-mp="1bf2iog0xzpbb">{point}</span>
                      </li>)}
                  </ul>
                </motion.article>)}
            </div>
          </div>
        </div>
      </section>

      <section id="competencies" className="bg-navy-900 py-20 lg:py-24" aria-labelledby="competencies-heading" data-id="element-428" data-mp="35uredx58pk01">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-429" data-mp="30vwjvxxwu703">
          <div id="competencies-heading" data-id="element-430" data-mp="30xr8bm8e4h8x">
            <SectionHeading eyebrow="Board Competencies" title="Competency map for a board skills matrix" description="How her capability maps to the competencies boards are required to hold collectively." tone="dark" data-id="element-431" data-mp="2d5k8ue7dbu5a" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-432" data-mp="2i4x2piwnq1hd">
            {boardCompetencies.map(competency => <li key={competency.name} className="flex flex-col bg-navy-900 p-8" data-id="element-433" data-mp="1idtqcf5m4um">
                <h3 className="font-display text-base font-bold leading-snug text-white" data-id="element-434" data-mp="3tk29oz3tmm6s">
                  {competency.name}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-435" data-mp="wq67tj47tedc">
                  {competency.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}